const isDev = window.location.port === '3000';
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || (isDev ? `http://${window.location.hostname}:4000/api/v1` : "/api/v1");
